import { ICommandBase } from "@Alternatives/cqrs";
import { AttributeFormDefinitionDTO } from "@Alternatives/Model";


export class CreateFormCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Forms.Commands.CreateFormCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Name: string;
	SourceId: number | null;

	constructor(workspaceId: number, projectId: number, formId: number, name: string, sourceId: number | null)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = formId.toString();
		this.Name = name;
		this.SourceId = sourceId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Forms.Commands.CreateFormCommandV1, TCh.Domain.Alternatives';
	}
}

export class RenameFormCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Forms.Commands.RenameFormCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Name: string;

	constructor(workspaceId: number, projectId: number, formId: number, name: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = formId.toString();
		this.Name = name;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Forms.Commands.RenameFormCommandV1, TCh.Domain.Alternatives';
	}
}


export class UpdateFormDefinitionCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Forms.Commands.UpdateFormDefinitionCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;
	Name: string;
	Description: string | null;
	Blurb: string | null;
	BlurbVisible: boolean;
	NameReadonly: boolean;
	DescriptionReadonly: boolean;
	StatusReadonly: boolean;
	IncludeDescription: boolean;
	IncludeStatus: boolean;
	AttributesDefinitions: AttributeFormDefinitionDTO[];

	constructor(workspaceId: number, projectId: number, alternativesListId: number, formId: number, name: string,
		description: string | null, blurb: string | null, blurbVisible: boolean, nameReadonly: boolean,
		descriptionReadonly: boolean, statusReadonly: boolean, includeDescription: boolean, includeStatus: boolean, attributesDefinitions: AttributeFormDefinitionDTO[])
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.AlternativesListId = alternativesListId;
		this.Id = formId.toString();
		this.Name = name;
		this.Description = description;
		this.Blurb = blurb;
		this.BlurbVisible = blurbVisible;
		this.NameReadonly = nameReadonly;
		this.DescriptionReadonly = descriptionReadonly;
		this.StatusReadonly = statusReadonly;
		this.IncludeDescription = includeDescription;
		this.IncludeStatus = includeStatus;
		this.AttributesDefinitions = attributesDefinitions;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Forms.Commands.UpdateFormDefinitionCommandV1, TCh.Domain.Alternatives';
	}
}

export class DeleteFormCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Forms.Commands.DeleteFormCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	AlternativesListId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;		
		this.AlternativesListId = alternativesListId;
		this.Id = formId.toString();
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Forms.Commands.DeleteFormCommandV1, TCh.Domain.Alternatives';
	}
}
